import React, { PropsWithChildren, useContext, useEffect, useState } from 'react'
import { styled, WebSpinner } from '~/app/components'

/**
 * LoadingProvider component
 * author: soojin.oh
 */

export const LoadingContext = React.createContext({
  isLoading: false,
  setLoading: (_isLoading: boolean) => {},
})

const Container = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
`

export const Loading = () => {
  return (
    <Container>
      <WebSpinner />
    </Container>
  )
}

// LoadingProvider component
const LoadingProvider = function ({ children }: PropsWithChildren) {
  const [isLoading, setLoading] = useState(false)
  return (
    <LoadingContext.Provider value={{ isLoading, setLoading }}>
      {children}
      {isLoading && <Loading />}
    </LoadingContext.Provider>
  )
}

export default LoadingProvider

/**
 * 로딩 컴포넌트를 설정하기 위한 hook
 * @param loading loading 여부
 */
export const useLoading = function (loading: boolean) {
  const { setLoading } = useContext(LoadingContext)
  useEffect(() => {
    setLoading(loading)
    return () => setLoading(false)
  }, [loading])
  return
}
